import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfText = React.memo(({ node }: AdfNodeProps) => {
    const { marks } = node;

    if (!marks || marks.length === 0) {
        return <span>{node.text}</span>;
    }

    return marks.reduce((element, mark) => {
        switch (mark.type) {
            case 'strong':
                return <strong>{element}</strong>;
            case 'em':
                return <em>{element}</em>;
            case 'underline':
                return <u>{element}</u>;
            case 'strike':
                return <s>{element}</s>;
            case 'code':
                return <code>{element}</code>;
            case 'link':
                return <a
                    href={mark.attrs?.href}
                    title={mark.attrs?.title}
                    target="_blank"
                    rel="noopener noreferrer"
                >{element}</a>;
            case 'textColor':
                return <span style={{ color: mark.attrs?.color }}>{element}</span>;
            case 'subsup':
                return mark.attrs?.type === 'sub' ?
                    <sub>{element}</sub> :
                    <sup>{element}</sup>;
            default:
                return element;
        }
    }, <span>{node.text}</span> as React.ReactElement);
});
